export enum OelSections {
    "Sample Results" = 0,
    "Goodness of fit" = 1,
    "Log-normal fit" = 2,
}
